export interface JwtPayload {
  sub: string
  name: string
  email?: string
  iss: string
  exp: number
  nbf: number
  iat?: number
}


export class InvalidJWTToken extends Error {}


export class JWT {
  sub: string
  name: string
  email?: string
  iss: string
  exp: number
  nbf: number
  iat?: number

  constructor (token: string) {
    const parsedJWT = this.parseJwt(token)
    this.sub = parsedJWT.sub
    this.name = parsedJWT.name
    this.email = parsedJWT.email
    this.iss = parsedJWT.iss
    this.exp = parsedJWT.exp
    this.nbf = parsedJWT.nbf
    this.iat = parsedJWT.iat
  }

  private parseJwt (token: string): JwtPayload {
    const splittedToken = token.split('.')
    const base64Url = splittedToken[1]
    if (!base64Url) {
      throw new InvalidJWTToken('Invalid JWT Token')
    }
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map((c) => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))
    return JSON.parse(jsonPayload)
  }

  public getLoginDatetime () {
    return new Date(this.nbf * 1000)
  }
}
